import { Box, Typography } from '@mui/material';
import React from 'react';
import { defineMessages, useIntl } from 'react-intl';

import ContactForm from '@components/ContactForm/ContactForm';

import { RELATED_PERSON_RELATIONSHIP_MAP } from '@constants/option-types/related-person';

import { HorizontalRule } from '@layouts/AuthLayout';

import type { PatientContactType } from '@models/contact';
import type {
  RelatedPersonRecord, // RelatedPersonType,
} from '@models/related-person';

import { capitalize } from '@utils/format';

import type { ContactModel } from 'generated/types';

import { FontWeight } from '../../../../theme/typography';

const messages = defineMessages({
  title: {
    id: 'contactForm.title',
    defaultMessage: '{action} {person}',
  },
  add: {
    id: 'GLOBAL.add',
    defaultMessage: 'Add',
  },
  edit: {
    id: 'GLOBAL.edit',
    defaultMessage: 'Edit',
  },
  relatedPerson: {
    id: 'contactForm.relatedPerson',
    defaultMessage: 'Related Person',
  },
  careTeam: {
    id: 'contactForm.careTeamContact',
    defaultMessage: 'Care Team Contact',
  },
});

export default function ContactModalContent({
  onClose,
  person,
  type = 'emergency-contact',
  contactType = 'related-person',
  contact,
  organization_ids,
}: {
  onClose: () => void;
  /**
   * Existing related person to be edited
   */
  person?: RelatedPersonRecord;
  /**
   * Type of related person to be added
   */
  type?: string;
  contact?: ContactModel;
  contactType?: PatientContactType;
  id?: string;
  /** Field should only be passed for care team member updates
   * Used to populate CareTeam.managingOrganization field
   */
  organization_ids?: string[];
}) {
  const { formatMessage } = useIntl();
  const handleClose = () => onClose();

  return (
    <Box sx={{ textAlign: 'center', p: 3 }}>
      <Typography
        color="primary.main"
        variant="h5"
        sx={{ fontWeight: FontWeight.Light }}
      >
        {formatMessage(messages.title, {
          action: formatMessage(
            person || contact ? messages.edit : messages.add
          ),
          person: type
            ? capitalize(RELATED_PERSON_RELATIONSHIP_MAP.get(type) ?? type)
            : (contact?.role_name ??
              formatMessage(
                contactType === 'care-team'
                  ? messages.careTeam
                  : messages.relatedPerson
              )),
        })}
      </Typography>
      <HorizontalRule />
      <ContactForm
        contact={contact}
        contactType={contactType}
        onClose={handleClose}
        organization_ids={organization_ids}
        person={person}
        type={type}
      />
    </Box>
  );
}
